













import Vue from "vue";

type MsgLevel = "debug" | "info" | "error";

interface Props {
  level: MsgLevel;
  text?: string;
}

export default Vue.extend<Props>({
  name: "JzMicMsg",
  functional: true,
  props: {
    level: { type: String as () => MsgLevel, required: true },
    text: { type: String, default: undefined }
  }
});
